<template>
  <LinkButton
    type="button"
    tag="button"
    asterix
    @click="open"
  >
    *
  </LinkButton>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';
import { openModal } from '~/composables/modal';

const open = (e: Event) => {
  e.preventDefault();
  openModal({
    heading: 'Aktionsbedingungen',
    closeOnBackdrop: true,
    content: `MagentaMobil-Kunden mit Laufzeitvertrag erhalten bis zu 10&nbsp;€ Gutschrift auf ihrer Mobilfunkrechnung, wenn sie nach Anmeldung zur Aktion im Aktionszeitraum 01.09.2026–31.12.2026 bis zum Ende des Folgemonats der Registrierung die Bezahlfunktion „Zahl einfach per Handyrechnung“ für eine konkret beworbene Transaktion nutzen. Die Gutschrift erfolgt in Höhe der für den Dienst „Zahl einfach per Handyrechnung“ konkret beworbenen und durchgeführten Transaktion, die nach Registrierung im gleichen Monat oder im darauffolgenden Monat getätigt wird, bis max. 10&nbsp;€. Falls der Wert dieser Transaktion über 10&nbsp;€ liegt, werden 10&nbsp;€ gutgeschrieben. Die Gutschrift erfolgt nach spätestens 3 Monaten auf der Mobilfunkrechnung. Bei Widerruf einer qualifizierenden Bezahlung erfolgt keine Gutschrift. Pro Kunde ist nur eine Gutschrift einlösbar. Es gelten die Teilnahmebedingungen und Datenschutzhinweise.
<br /><br />
Ein Angebot von: Telekom Deutschland GmbH, Landgrabenweg 149, 53227 Bonn.
<br /><br />
Änderungen und Irrtümer vorbehalten.`,
  });
};
</script>
